import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeHeader from '../components/homeHeader';
import {v4 as  uuidV4} from 'uuid';
import Axios from 'axios';
import MyDocuments from '../components/MyDocuments';
import SharedWithMe from '../components/SharedWithMe';
import {Helmet} from 'react-helmet';

export default function Home() {

    const navigate = useNavigate();
    const date = new Date();

    const [toggle, setToggle] = useState(0);

    function CreateDocx()
    {
        const id = uuidV4();
        //! Database Register Here
        // let data = {
        //     urlkey: id,
        //     // owner: ,
        //     contents: " ",
        //     viewers: [],
        //     editors: [],
        //     dateCreated: `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`,
        //     lastEdited: `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
        // }
        // console.log(data);
        // DatabaseDocument(data);
        //! Opening After REsp From Db Would be Better
        navigate(`/document/${id}`);
    }

    return (
        <section>
            <Helmet>
                <title>Docx - Home</title>
            </Helmet>
            <HomeHeader />
            <div className=''>
                <div className='bg-gray-200 w-full py-10 px-6'>
                    <div onClick={() => CreateDocx()} className='bg-white min-h-[180px] max-h-[200px] max-w-[150px] flex items-center justify-center' >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-14 w-14 text-gray-600 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className='p-8 flex justify-end sticky top-20 z-10 w-fit float-right'>
                <button onClick={() => setToggle(0)}className={toggle==0?'font-semibold text-xl bg-blue-500 text-white py-2 px-6':"font-semibold text-2xl border border-gray-800 py-2 px-6 hover:bg-blue-400 hover:text-white hover:border-blue-300 transition-all"}>Mine</button>
                <button onClick={() => setToggle(1)} className={toggle==1?'font-semibold text-xl bg-blue-500 text-white py-2 px-6':"font-semibold text-2xl border border-gray-800 py-2 px-6 hover:bg-blue-400 hover:text-white hover:border-blue-300 transition-all"}>Shared with me</button>
            </div>
            <div className='clear-both'></div>
            {toggle==0?<MyDocuments />:<SharedWithMe />}

        </section>
    )
}
